import React, { useCallback } from "react";
import cls from "classnames";
import { useT } from "@al/next/al-ex";
import { Button, LazyImage } from "@al/akui-mobile";
import Router from "@al/next/router";

import goBack from "~/common/utils/goBack";

import errorImg from "./images/network_error.png";
import styles from "./styles.scss";

export interface ErrorBlockProps {
  type?: "networkError" | "pageError";
  className?: string;
  style?: React.CSSProperties;
  imgSrc?: string;
  btnClassName?: string;
  hideBtn?: boolean;
  text?: string;
  buttons?: React.ReactNode;
  onRefresh?: () => void;
  onBack?: () => void;
  onBackToHome?: () => void;
}

export default function ErrorBlock(props: ErrorBlockProps): JSX.Element {
  const {
    type = "networkError",
    className,
    style,
    imgSrc,
    btnClassName,
    hideBtn,
    text,
    onRefresh,
    onBack,
    // onBackToHome,
    buttons,
  } = props;
  const t = useT();
  // const ctx = useCtx();
  const handleRefresh = useCallback(() => {
    onRefresh ? onRefresh() : Router.reload();
  }, [onRefresh]);
  const handleBack = useCallback(() => {
    onBack ? onBack() : goBack();
  }, [onBack]);
  // const handleBackToHome = useCallback(() => {
  //   onBackToHome ? onBackToHome() : ctx.router.push("/main/home");
  // }, [onBack]);
  return (
    <div className={cls(styles.root, className)} style={style} onTouchStart={(e): void => e.stopPropagation()}>
      <LazyImage closeLazy mode="noPreOrFail" width="1.5rem" height="1.5rem" src={imgSrc || errorImg} />
      {/* 文字 */}
      <div className={styles.text}>
        {text ||
          {
            networkError: t("global:网络状况不佳，请重新刷新"),
            pageError: t("global:页面内容不属于该地区暂不能访问"),
          }[type || "networkError"]}
      </div>
      {/* 按钮 */}
      {!hideBtn &&
        {
          networkError: buttons ?? (
            <>
              <Button className={cls(styles.btn, btnClassName)} color="primary" onClick={handleRefresh}>
                {t("global:重新刷新")}
              </Button>
              {/* <Button
                className={cls(styles.btn, btnClassName)}
                color="primary"
                fill="outline"
                onClick={handleBackToHome}
              >
                {t("global:返回首页")}
              </Button> */}
            </>
          ),
          pageError: buttons ?? (
            <Button className={cls(styles.btn, btnClassName)} color="primary" fill="outline" onClick={handleBack}>
              {t("global:返回")}
            </Button>
          ),
        }[type || "networkError"]}
    </div>
  );
}
